<template>
    <div id="data-list-thumb-view" class="data-list-container">
      <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @emitRefresh = "refresh"
      :data="sidebarData"
    />
    <role-permission
      :isSidebarActive="addNewDataPopup"
      @closeSidebar="toggleDataPopup"
      :data="popupData"
      :roleName="selectedRoleName"
    />
    <vs-popup
      class="holamundo"
      title="Rol Sil"
      :active.sync="deletePopupActive"
      v-esc="escapeDelete"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Rolü Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          id="removeButton"
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
        <vs-table
        ref="table"
        :data="roleList"
        v-model="selected">
        <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row
          id="panelHeaderRow"
          vs-type="flex"
          vs-w="12"
          vs-justify="space-between"
        >
          <vs-col
            id="panel-actions"
            vs-type="flex"
            class="w-auto"
            vs-justify="center"
          >
            <vs-row vs-type="flex" vs-w="12">
              <vs-col v-if="$isCenterBranch()" vs-type="flex" class="w-auto">
                <vx-tooltip text="Yeni Rol" position="top">
                  <vs-button
                    @click="addNewData"
                    class="panel-action text-success xlarge-button panel-action-box-shadow"
                    color="transparent"
                    icon-pack="feather"
                    icon="icon-plus"
                  >
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
        <template slot="thead">
          <vs-th class="w-9/12 justify-center">
            <vs-button
              icon-pack="feather"
              color="primary"
              type="flat"
              >Rol İsmi
            </vs-button>
          </vs-th>
          <vs-th class="w-3/12 justify-center">
            <vs-button
              icon-pack="feather"
              color="primary"
              type="flat"
              >İşlemler
            </vs-button>
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody class="text-center">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="w-5/12">
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td class="w-1/12 whitespace-no-wrap">
              <feather-icon
                v-if="$isSuperAdmin()"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  deletedId = tr.id;
                  deletePopupActive = true;
                "
              />
            </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    </div>
</template>

<script>
  import { getRoleList,getRolePermissions,deleteRole } from "@/api/Role.js";
  import DataViewSidebar from "./NewRole.vue";
  import RolePermission from "./RolePermission.vue";

export default {
  components: {
    DataViewSidebar,
    RolePermission
  },
data(){
return{
    roleList:[],
    selected: "",
    addNewDataSidebar: false,
    addNewDataPopup: false,
    sidebarData: {},
    popupData: [],
    selectedRoleName:'',
    deletePopupActive: false,
    deletedId: null,
}
},
methods:{
  escapeDelete() {
      if (this.deletePopupActive == true) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
  addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    getRoles(){
        var result = this.getRoleList();
        console.log(result);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    toggleDataPopup(val = false) {
      this.addNewDataPopup = val;
      val == false ? (this.selected = "") : null;
    },
    refresh: async function () {
      var result = await getRoleList();
      this.roleList = result.data;
    },
    deleteData: async function(id) {
      if (!this.$isSuperAdmin()) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Rol silme işlemi sadece superadmin yetkisindedir !",
        });
        return;
      }
      await deleteRole(id).then((res) => {
        if (res && res.status == 200) {
          this.$vs.notify({
              color: "success",
              title: "Silme İşlemi",
              text: "Rol Başarıyla Silindi",
            });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !",
          });
        }
      }).catch((error) => {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: error.response.data.Errors[0].Message
                });
              });
              await this.refresh();
              this.deletePopupActive = false;
    },
},
created: async function () {
    var result = await getRoleList();
    this.roleList = result.data;
},
watch:{
    selected: async function (val) {
       console.log(val);
       var resultt = await getRolePermissions(val.id);
       this.popupData = resultt.data;
       this.selectedRoleName = val.name
       this.toggleDataPopup(true);
     }
}
}
</script>